import React from 'react'
import './Additional.css'

function Additional() {
  return (
    <div>
        <section className="inline-block-top">
          <div className="first-highlight">
            <div className="title-wrapper">iPhone 15 Pro</div>

            <div className="discription-wrapper">Titanium. So strong. So Pro.</div>

            <div className="link-wrapper">
              <ul>
                <li><a href="#"></a>Learn more</li>
                <li><a href="#"></a>Buy</li>
              </ul>
            </div>
          </div>
          <div className="second-highlight">
            <div className="title-wrapper">iPhone 15 Pro</div>

            <div className="discription-wrapper">Titanium. So strong. So Pro.</div>

            <div className="link-wrapper">
              <ul>
                <li><a href="#"></a>Learn more</li>
                <li><a href="#"></a>Buy</li>
              </ul>
            </div>
          </div>
          <div className="third-highlight">
            <div className="title-wrapper">iPhone 15 Pro</div>

            <div className="discription-wrapper">Titanium. So strong. So Pro.</div>

            <div className="link-wrapper">
              <ul>
                <li><a href="#"></a>Learn more</li>
                <li><a href="#"></a>Buy</li>
              </ul>
            </div>
          </div>
        </section>
    </div>
  )
}

export default Additional